// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserAgreement_wrapper__yrfqL"};